import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type UserMutualFollowsVariables = Types.Exact<{
  publicKey: Types.Scalars['String'];
  currentUserPublicKey: Types.Scalars['String'];
  offset: Types.Scalars['Int'];
  limit: Types.Scalars['Int'];
}>;


export type UserMutualFollows = { user: Types.Maybe<{ mutualFollows: Array<(
      Pick<Types.Follow, 'id'>
      & { user: Pick<Types.User, 'name' | 'username' | 'profileImageUrl' | 'publicKey'> }
    )>, mutualFollowsCount: { aggregate: Types.Maybe<Pick<Types.Follow_Aggregate_Fields, 'count'>> } }> };



export const UserMutualFollowsDocument = /*#__PURE__*/ `
    query UserMutualFollows($publicKey: String!, $currentUserPublicKey: String!, $offset: Int!, $limit: Int!) {
  user: user_by_pk(publicKey: $publicKey) {
    mutualFollows: follows(
      where: {isFollowing: {_eq: true}, userByFollowingUser: {follows: {user: {_eq: $currentUserPublicKey}, isFollowing: {_eq: true}}}, user: {_neq: $currentUserPublicKey}}
      offset: $offset
      limit: $limit
    ) {
      id
      user: userByFollowingUser {
        name
        username
        profileImageUrl
        publicKey
      }
    }
    mutualFollowsCount: follows_aggregate(
      where: {isFollowing: {_eq: true}, userByFollowingUser: {follows: {user: {_eq: $currentUserPublicKey}, isFollowing: {_eq: true}}}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

export const useUserMutualFollows = <
      TData = UserMutualFollows,
      TError = ClientError
    >(
      variables: UserMutualFollowsVariables,
      options?: Omit<UseQueryOptions<UserMutualFollows, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserMutualFollows, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UserMutualFollows, TError, TData>(
      {
    queryKey: ['UserMutualFollows', variables],
    queryFn: hasuraFetcher<UserMutualFollows, UserMutualFollowsVariables>(UserMutualFollowsDocument, variables),
    ...options
  }
    )};

useUserMutualFollows.getKey = (variables: UserMutualFollowsVariables) => ['UserMutualFollows', variables];

export const useInfiniteUserMutualFollows = <
      TData = InfiniteData<UserMutualFollows>,
      TError = ClientError
    >(
      variables: UserMutualFollowsVariables,
      options: Omit<UseInfiniteQueryOptions<UserMutualFollows, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserMutualFollows, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserMutualFollows, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['UserMutualFollows.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<UserMutualFollows, UserMutualFollowsVariables>(UserMutualFollowsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserMutualFollows.getKey = (variables: UserMutualFollowsVariables) => ['UserMutualFollows.infinite', variables];


useUserMutualFollows.fetcher = (variables: UserMutualFollowsVariables, options?: RequestInit['headers']) => hasuraFetcher<UserMutualFollows, UserMutualFollowsVariables>(UserMutualFollowsDocument, variables, options);
